import ga from 'react-ga';

import {USER_LOGGED_IN, USER_NOT_LOGGED_IN, USER_CHECK_LOGIN} from 'constants/actiontypes';
import Cookies from 'js-cookie';
import Config from 'config';

import Fetch from 'network';

import { showNotificationWithTimeout as notify } from 'actioncreators/notification';

export const loginUser = (data) => ({
  type: USER_LOGGED_IN,
  data
});

export const logoutUser = (url) => ({
  type: USER_NOT_LOGGED_IN,
  url
});

export const checkLogin = () => ({
  type: USER_CHECK_LOGIN
});


export const getUser = () => (dispatch) => {
  dispatch(checkLogin());
  let session_id = Cookies.get(Config.SESSION_COOKIE_NAME);
  let data = Cookies.get(Config.USERINFO_COOKIE_NAME);
  if (session_id && data) {
    data = data.replace(/"/g, '');
    const tdata = window.atob(data);
    const userinfo = JSON.parse(tdata);
    dispatch(loginUser(userinfo));
  } else {
    dispatch(logoutUser());
    dispatch(notify('Please login to continue.'));
  }
};



/** WEBPACK FOOTER **
 ** ./actioncreators/user.js
 **/